"use client";

import { c as _c } from "react/compiler-runtime";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
import SecondaryButton from "@/components/utils/button/SecondaryButton";
import type { ApiDrop } from "@/generated/models/ApiDrop";
interface ResubmitDeleteConfirmationProps {
  readonly originalDrop: ApiDrop;
  readonly replacementDrop: ApiDrop;
  readonly isDeleting: boolean;
  readonly error: string | null;
  readonly onDeleteOriginal: () => void;
  readonly onKeepBoth: () => void;
}
const getDropTitle = (drop: ApiDrop, fallback: string): string => {
  const metadataTitle = drop.metadata.find(metadata => metadata.data_key === "title")?.data_value;
  return metadataTitle ?? drop.title ?? fallback;
};
export function ResubmitDeleteConfirmation(t0) {
  const $ = _c(29);
  const {
    originalDrop,
    replacementDrop,
    isDeleting,
    error,
    onDeleteOriginal,
    onKeepBoth
  } = t0;
  let t1;
  if ($[0] !== originalDrop) {
    t1 = getDropTitle(originalDrop, "Original submission");
    $[0] = originalDrop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const originalTitle = t1;
  let t2;
  if ($[2] !== replacementDrop) {
    t2 = getDropTitle(replacementDrop, "New submission");
    $[2] = replacementDrop;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const replacementTitle = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-mb-6 tw-flex tw-flex-col tw-gap-y-3"><span className="tw-text-sm tw-font-semibold tw-uppercase tw-tracking-wide tw-text-primary-300">New version submitted</span><h4 className="tw-mb-0 tw-text-2xl tw-font-semibold tw-text-iron-100">Delete the original submission?</h4><p className="tw-mb-0 tw-text-sm tw-leading-6 tw-text-iron-400">Your edited submission is live. Delete the original to finish the resubmit flow, or keep both submissions for now.</p></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-iron-500">Original</span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== originalTitle) {
    t5 = <div>{t4}<p className="tw-mb-0 tw-mt-1 tw-text-sm tw-font-medium tw-text-iron-200">{originalTitle}</p></div>;
    $[6] = originalTitle;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-iron-500">New</span>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== replacementTitle) {
    t7 = <div>{t6}<p className="tw-mb-0 tw-mt-1 tw-text-sm tw-font-medium tw-text-iron-200">{replacementTitle}</p></div>;
    $[9] = replacementTitle;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <div className="tw-mb-6 tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900/60 tw-p-4"><div className="tw-grid tw-gap-4 sm:tw-grid-cols-2">{t5}{t7}</div></div>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== error) {
    t9 = error && <p className="tw-mb-6 tw-rounded-lg tw-bg-red/10 tw-p-3 tw-text-sm tw-font-medium tw-text-red">{error}</p>;
    $[14] = error;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isDeleting || $[17] !== onKeepBoth) {
    t10 = <SecondaryButton onClicked={onKeepBoth} disabled={isDeleting}>Keep Both for Now</SecondaryButton>;
    $[16] = isDeleting;
    $[17] = onKeepBoth;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== isDeleting || $[20] !== onDeleteOriginal) {
    t11 = <PrimaryButton onClicked={onDeleteOriginal} disabled={false} loading={isDeleting} padding="tw-px-5 tw-py-2.5">Delete Original</PrimaryButton>;
    $[19] = isDeleting;
    $[20] = onDeleteOriginal;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <div className="tw-flex tw-flex-col-reverse tw-gap-3 sm:tw-flex-row sm:tw-justify-end">{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t8 || $[27] !== t9) {
    t13 = <div className="tw-flex tw-h-full tw-items-center tw-justify-center tw-px-4 tw-py-8 md:tw-px-8"><div className="tw-w-full tw-max-w-xl">{t3}{t8}{t9}{t12}</div></div>;
    $[25] = t12;
    $[26] = t8;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}